import { render, staticRenderFns } from "./b-dropdown-multilevel.vue?vue&type=template&id=540bcf9c&scoped=true"
import script from "./b-dropdown-multilevel.vue?vue&type=script&lang=js"
export * from "./b-dropdown-multilevel.vue?vue&type=script&lang=js"
import style0 from "./b-dropdown-multilevel.vue?vue&type=style&index=0&id=540bcf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bcf9c",
  null
  
)

export default component.exports